var map = {
	"./ada.png": 4259,
	"./algolia-logo.png": 1508,
	"./atom.png": 1292,
	"./bch.png": 5528,
	"./bnb.png": 1261,
	"./bsv.png": 4454,
	"./btc.png": 714,
	"./dai.png": 377,
	"./dash.png": 5411,
	"./doge.png": 7008,
	"./dot.png": 802,
	"./eos.png": 428,
	"./eth.png": 6454,
	"./fio.png": 4537,
	"./firo.png": 2305,
	"./icon.png": 9812,
	"./lbc.png": 3806,
	"./link.png": 807,
	"./ltc.png": 1548,
	"./rvn.png": 4857,
	"./social/TikTok.png": 3829,
	"./social/applePodcasts.png": 7500,
	"./social/bitchute.png": 5511,
	"./social/bittube.png": 7600,
	"./social/cashapp.png": 9881,
	"./social/discord.png": 7579,
	"./social/dlive.png": 9169,
	"./social/facebook.png": 8607,
	"./social/flote.png": 9767,
	"./social/github.png": 5798,
	"./social/instagram.png": 7479,
	"./social/lbry.png": 9058,
	"./social/linkedin.png": 1213,
	"./social/medium.png": 1382,
	"./social/memo.png": 7549,
	"./social/minds.png": 4984,
	"./social/openBazaar.png": 4646,
	"./social/open_bazaar.png": 3481,
	"./social/patreon.png": 4376,
	"./social/paypal.png": 1310,
	"./social/read.png": 3247,
	"./social/reddit.png": 2999,
	"./social/soundcloud.png": 7223,
	"./social/spotify.png": 261,
	"./social/steemit.png": 904,
	"./social/stitcher.png": 7869,
	"./social/telegram.png": 1778,
	"./social/twetch.png": 2106,
	"./social/twitch.png": 5678,
	"./social/twitter.png": 3686,
	"./social/web.png": 6561,
	"./social/youtube.png": 1259,
	"./splash.png": 762,
	"./tree.png": 9135,
	"./trx.png": 7861,
	"./usdt.png": 5363,
	"./xlm.png": 6014,
	"./xmr.png": 1506,
	"./xrp.png": 1177,
	"./xtz.png": 5849,
	"./zec.png": 1301,
	"./zecshield.png": 6422
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7060;